import { useState, useMemo } from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '../../../../store/store';
import {
  BlacklistRequest,
  blacklistStatus,
  selectBlacklist,
  totalBlacklist,
} from '../../../../store/reducers/BlacklistSlice';
import { phone } from '../../../../utils/phone';
import { formatDateTime } from '../../../../utils';
import { BlacklistCurrent } from '../../../../models/Blacklist/Blacklist';
import { blacklistServerSortDefaults } from '../../../shared/journalSortMaps';

const DEFAULT_PAGE_SIZE: number = 20;

export const useBlacklistState = () => {
  const blacklist = useAppSelector(selectBlacklist);
  const total = useAppSelector(totalBlacklist);
  const status = useAppSelector(blacklistStatus);
  const [index, setIndex] = useState<number>();
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [callRequest, setCallRequest] = useState<BlacklistRequest>({
    From: dayjs().format('YYYY-MM-DD'),
    To: dayjs().format('YYYY-MM-DD'),
    PageIndex: 0,
    PageSize: pageSize,
    SortKeySelector: blacklistServerSortDefaults.SortKeySelector,
    TextSearch: '',
    SortOrder: blacklistServerSortDefaults.SortOrder,
  } as BlacklistRequest);

  const currentBlacklist: BlacklistCurrent[] = useMemo(() => {
    if (!blacklist) return [];

    return blacklist.map((item, index) => {
      return {
        id: item.id,
        comment: item.comment,
        useForInbound: item.useForInbound,
        useForOutbound: item.useForOutbound,
        phone: phone(item.phone),
        created: formatDateTime(item.created),
        reason: item.reason,
        indexId: index,
      };
    });
  }, [blacklist]);

  const allBlacklist: BlacklistCurrent[] = useMemo(
    () => [...currentBlacklist],
    [currentBlacklist],
  );

  return {
    setIndex,
    status,
    pageSize,
    setPageSize,
    callRequest,
    setCallRequest,
    total,
    currentBlacklist,
    allBlacklist,
  };
};
